import { OrganType } from '@nkr/enums/organ-type';
import React, { FormEvent } from 'react';
import { Button, ButtonToolbar, FormControl, ToggleButton, ToggleButtonGroup, Well } from 'react-bootstrap';
import { FilterGroup } from './filter-group';

interface IProps {
    startDate: string,
    endDate: string,
    filterGroup: FilterGroup,
    display: number[],
    organTypes: OrganType[],
    epletMM: number,
    facilitatedTxps: number,
    showDateWarning: boolean,
    onDateChange: (name: string, value: string) => void,
    onSearch: () => void,
    onRadioFilterChange: (value: FilterGroup) => void,
    onDisplayChange: (display: any) => void,
    onChangeOrganType: (organTypes: OrganType[]) => void
}

const Filter: React.FC<IProps> = ({
    startDate, endDate, filterGroup, display, epletMM, facilitatedTxps, showDateWarning, organTypes,
    onDateChange, onSearch, onRadioFilterChange, onDisplayChange, onChangeOrganType
}) => {
    const handleDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;
        onDateChange(name, value);
    };

    const facilitatedTxpsDisplay = filterGroup == FilterGroup.Facilitated ? 'flex' : 'none';
    const organValue = organTypes.length == 2 ? -1 : organTypes.includes(OrganType.Kidney) ? OrganType.Kidney : OrganType.Liver;

    return (
        <>
            {showDateWarning && (
                <div style={{ backgroundColor: '#843534', color: 'white', padding: '2px 5px', borderTopLeftRadius: 4, borderTopRightRadius: 4 }}>
                    Please make sure that the start and end dates are valid and that the start date is on or before the end date...
                </div>
            )}

            <Well bsSize='sm' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                        <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                        <div>
                            <FormControl
                                type='date'
                                name='startDate'
                                value={startDate}
                                onChange={handleDateChange}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 5 }}>
                        <div style={{ marginRight: 5 }}>End Date:</div>
                        <div>
                            <FormControl
                                type='date'
                                name='endDate'
                                value={endDate}
                                onChange={handleDateChange}
                            />
                        </div>
                    </div>
                    <div>
                        <Button bsStyle={'primary'} onClick={onSearch}>Search</Button>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }} >
                        <div style={{ marginRight: 5 }}>Filters:</div>
                        <ButtonToolbar>
                            <ToggleButtonGroup type='radio' name='filter-options' value={filterGroup}>
                                <ToggleButton className='btn-bg' value={0} onChange={() => onRadioFilterChange(FilterGroup.All)}>
                                    All
                                </ToggleButton>
                                <ToggleButton className='btn-bg' value={1} onChange={() => onRadioFilterChange(FilterGroup.Facilitated)}>
                                    Fac
                                </ToggleButton>
                                <ToggleButton className='btn-bg' value={2} onChange={() => onRadioFilterChange(FilterGroup.NonFacilitated)}>
                                    Non-Fac
                                </ToggleButton>
                                <ToggleButton className='btn-bg' value={3} onChange={() => onRadioFilterChange(FilterGroup.MsOnly)}>
                                    MS
                                </ToggleButton>
                                <ToggleButton className='btn-bg' value={4} onChange={() => onRadioFilterChange(FilterGroup.KflOnly)}>
                                    KFL
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </ButtonToolbar>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
                        <div style={{ marginRight: 5 }}>Display:</div>
                        <ToggleButtonGroup type='checkbox' value={display} onChange={onDisplayChange}>
                            <ToggleButton value={1}>Completed</ToggleButton>
                            <ToggleButton value={2}>Pending</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 25 }}>
                        <div style={{ marginRight: 5 }}>Organ:</div>
                        <FormControl
                            componentClass='select'
                            value={organValue}
                            style={{ width: 100 }}
                            onChange={(e: any) => {
                                let value = parseInt(e.currentTarget.value);
                                onChangeOrganType(value == -1 ? [OrganType.Kidney, OrganType.Liver] : [value]);
                            }}
                        >
                            <option value={-1}>All</option>
                            <option value={OrganType.Kidney}>Kidney</option>
                            <option value={OrganType.Liver}>Liver</option>
                        </FormControl>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
                        <div style={{ marginRight: 5 }}>Low Eplet MM: <b>{epletMM}%</b></div>
                    </div>
                    <div style={{ display: facilitatedTxpsDisplay, alignItems: 'center', marginLeft: 30 }}>
                        <div style={{ marginRight: 5 }}>Facilitated TXP Total: <b>{facilitatedTxps}</b></div>
                    </div>
                </div>
            </Well>
        </>
    );
}

export default Filter;